const config = {
    region: 'eu-west-1',
	UserPoolId: 'eu-west-1_IRcvk8Flr',
    ClientId: '5mmbck2nmmjg19lcndvs1qtb57',
    IdentityPoolId: 'eu-west-1:631f727d-46e7-4821-a0cf-77ba2ac6eeda',
    AppSyncEndpoint: 'https://fbpat5pmmvcudpdfinovbyxlim.appsync-api.eu-west-1.amazonaws.com/graphql'
};

export default config;